import { TOKEN_LOADED } from '../helpers/constants';
import { dispatchEvent } from '../helpers/customEvent';
import { initAdvisors } from './advisor';
import * as settings from './settings';
import { requestNoHeaders } from '../helpers/request';
import faq from '../components/Faq';
import isStageEnv from '../helpers/isStageEnv';

let _user;

export const complete = (user) => {
  const accessToken = isStageEnv() ? "#access_token" : "#id_token";
  _user = user;

  if (window.location.hash.indexOf(accessToken) > -1) {
    window.history.replaceState({}, window.document.title, ".");
  }

  dispatchEvent(TOKEN_LOADED);

  faq(user);

  initAdvisors(user);
};

export const getToken = () => {
  return _user;
};

let clearAndRevokeToken = () => {
  window.localStorage.clear();
  window.sessionStorage.clear();
  window.location.reload();
}

export const revokeToken = () => {
  const url = isStageEnv() ? `${settings.authority}/oidc/logout?post_logout_redirect_uri=${settings.post_logout_redirect_uri}&client_id=${settings.client_id}` :
              `${settings.authority}/account/logout`;
              
  requestNoHeaders({url: url}, () => clearAndRevokeToken());
};
